/*
 * @Description: 
 * @Author: git config user.name
 * @Date: 2025-03-24 16:15:27
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-03-25 11:34:25
 * @FilePath: \ngs_platform_manage_admin\src\api\modules\advertisement.js
 */

// 网站侧广告栏页面 接口集合
import request from '../request.js' 

// 分页查询  ============徐仲阳
export const getDefinePageList = function (data) {
    return request({
        url: '/webSystem/getListForBannerPage',
        method: 'post',
        data
    })
}


// 根据不同的条件获取集合 新增配置  ============徐仲阳
export const getListByDifferentConditions = function (data) {
    return request({
        url: '/webSystem/getListByDifferentConditions',
        method: 'post',
        data
    })
}

//应用项目新增/修改(下一步)  ================徐仲阳
export const insertOrUpdateWebSystem = function (data) {
    return request({
        url: '/webSystem/insertOrUpdateWebSystem',
        method: 'post',
        data
    })
}

//删除  ============徐仲阳
export const deleteSystem = function (data) {
    return request({
        url: '/webSystem/deleteSystem',
        method: 'post',
        data
    })
}

//获取侧广告位列表  ============徐仲阳
export const getWebBannerList = function (data) {
    return request({
        url: '/webSystem/getWebBannerList',
        method: 'post',
        data
    })
}


//新增/修改banner侧广告  ============徐仲阳
export const insertOrUpdateBanner = function (data) {
    return request({
        url: '/webSystem/insertOrUpdateBanner',
        method: 'post',
        data
    })
}

//变更侧广告状态   ============徐仲阳
export const updateBanner = function (data) {
    return request({
        url: '/webSystem/updateBanner',
        method: 'post',
        data
    })
}